// Names of things used in query parameters.

export const PUBLICATION_SHARE_KEY_KEY = "shareKey";
export const PUBLICATION_SEARCH_KEY = "publication";
export const PUBLICATION_SHOW_MAP_KEY = "showMap";
export const PUBLICATION_SELECTED_COMMENT_KEY = "selectedComment";

// This is used to indicate that the user has been redirected from a publication to a project,
//  so we can show a more helpful error message if the project is not found or the user doesn't have access to it.
export const FROM_PUBLICATION_KEY = "fromPublication";

// To filter the list of projects on contributor
export const FILTER_CONTRIBUTOR_ID_KEY = "contributorId";

// The selected schematisation revision, used by both project files and the catalogue
export const REVISION_ID_KEY = "revisionId";

// Processes
export const PROCESS_SEARCH_KEY = "process";
export const JOB_SEARCH_KEY = "job";
export const FROM_JOB_SEARCH_KEY = "sourceJob";
export const WORKFLOW_SEARCH_KEY = "workflow";

// Catalogue
export const SELECTED_DATASET_SEARCH_KEY = "selectedDataset";

// Files
export const FILE_NAME_KEY = "fileName";
export const FILE_REF_KEY = "fileRef";
export const PATH_KEY = "path";
